import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * This component displays a question mark icon in a button and on click opens a tooltip menu.
 * Usage:
 * <mc-help-icon-button color="info">
 *   <p class="mc-my-menu">This is the tooltip menu content.</p>
 * </mc-help-icon-button>
 */
@Component({
  selector: 'mc-help-icon-button',
  templateUrl: './help-icon-button.component.html',
  styleUrls: ['./help-icon-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpIconButtonComponent {
  @Input() color: string = 'info';
  @Input() helpMenuClass: string | string[] | Set<string> | { [key: string]: any }
}
